import graphqlRequest from "../badgingRequest";
import CREATE_BADGE from "./createBadgeGraphql";

// creates a badge for a student with awarded=true
export async function createBadge(payload) {
  const response = await graphqlRequest(CREATE_BADGE, payload);
  return response.createStudentBadge;
}
